import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { ForgotLinks } from '../../components/layout/Auth/ForgotLinks';
import { goToLogin } from '../../helpers/location';
import { Auth } from '../layout/Auth';
import { requestForgot } from '../../store/actions/user';
import { SendEmailForm } from '../../components/pages/auth/SendEmailForm';
import './ForgotPassword.scss';

function ForgotPasswordComponent(props) {
  const { requestForgot } = props;

  return (
    <div className="forgot-password-page">
      <Auth title={<FormattedMessage
        id="app.forgot_password.forgot_password_page_title"/>}
            lead={<FormattedMessage
              id="app.forgot_password.forgot_password_page_description"/>}>
        <SendEmailForm
          request={requestForgot}
        />
      </Auth>
      <div className="forgot-password-page__links">
        <ForgotLinks logInLink={props.goToLogin}/>
      </div>
    </div>
  );
}

ForgotPasswordComponent.defaultProps = {
  goToLogin,
};

const mapActionsToProps = {
  requestForgot
};

const ForgotPassword = connect( null, mapActionsToProps )( ForgotPasswordComponent );

export { ForgotPassword, ForgotPasswordComponent };
